import React from "react";
import './ExamReportRoute.scss';
import ExamReportInformation from "../../components/exams/exam-report/exam-information/ExamReportInformation";
import ExamRankInformation from "../../components/exams/exam-report/exam-rank-information/ExamRankInformation";
import ExamResultService, { CourseStatisticView } from "../../services/exam/ExamResultService";
import IExamReportState, { IExamReportProps } from "./ExamReportRoute.models";
import PdfDownloader from "../../components/exams/exam-report/exam-report-pdf-downloader/PdfDownloader";
import { NavLink } from "react-router-dom";

export default class ExamReportRoute extends React.PureComponent<IExamReportProps, IExamReportState> {
    examResultService: ExamResultService;
    constructor(props: any) {
        super(props);
        this.state = { statusPage: 1, loading: false, allowedCheckResult: false };
        this.examResultService = new ExamResultService();
    }

    componentDidMount() {
        this.setState({ loading: true })
        if (this.props.examId != null && this.props.examResultId != null) {
            this.examResultService.getExamStatistics(this.props.examId, this.props.examResultId).then(response => {
                var examTotalLevel = response.courseStatistics.map((item: CourseStatisticView) => (item.level * item.coefficient)).reduce((a, b) => a + b, 0);
                var examTotalCoefficient = response.courseStatistics.map((item: CourseStatisticView) => item.coefficient).reduce((a, b) => a + b, 0);
                this.setState({
                    examInformation: { ...response, examLevel: Math.round(examTotalLevel / examTotalCoefficient) }, allowedCheckResult: response.examEnded,
                })
            })
            this.examResultService.getExamLevel(this.props.examId, this.props.examResultId).then(response => {
                if (response)
                    this.setState({ examRankInformation: response })
            }).finally(() => this.setState({ loading: false }))
        }
        if (this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.statusPage !== this.props.statusPage && this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
    }

    render(): React.ReactNode {
        let { statusPage, allowedCheckResult, examInformation } = this.state;

        return (<>
            <div className="content-menu exam-report-route-area px-4">
                {
                    allowedCheckResult ? <>
                        <div className="col-12">
                            <div className="tk-inline" style={{ marginBottom: "3px" }}>
                                <div className={"notspace header-title " + (statusPage === 1 ? "active " : " ") + (examInformation?.alreadyJoined ? "col-12" : "col-6")} onClick={() => this.setState({ statusPage: 1 })}>
                                    <label>اطلاعات و آمار آزمون</label>
                                </div>
                                {
                                    !examInformation?.alreadyJoined &&
                                    <div className={"col-6 notspace header-title " + (statusPage === 2 ? "active" : "")} onClick={() => this.setState({ statusPage: 2 })}>
                                        <label>تراز و رتبه</label>
                                    </div>
                                }
                            </div>
                        </div >
                        <div className="dropdown-list exam-report-route-area" id="exam-report-area">
                            <div className="tk-aling-right tk-padding-top" id="exam-report-content">
                                <div className="col-12">
                                    {!this.state.loading && this.contentView(statusPage)}
                                </div>
                            </div>
                        </div>
                        {
                            !this.state.loading && <PdfDownloader examInformation={this.state.examInformation} chartData={this.state.examRankInformation?.chartData} />
                        }
                    </> : <>
                        <div className="col-12 exam-question-view-area tk-title-middle pb-4">
                            <i className="mdi mdi-book-open-page-variant check-decagram" ></i>
                            <label className="text-muted" style={{ fontSize: "14px" }}>مدت زمان برگزاری آزمون به اتمام نرسیده است، نتایج بعد از پایان ازمون محاسبه و نمایش داده خواهد شد.</label>
                        </div>
                        <div className="fixed-footer">
                            <NavLink to={`/ViewExamResults`}>
                                <button className="btn btn-primary tk-full-width back-forward"> بازگشت</button >
                            </NavLink>
                        </div>
                    </>
                }
            </div>
        </>);
    }

    contentView = (statusPage: number) => {
        if (statusPage === 1) {
            return (<ExamReportInformation examInformation={this.state.examInformation} chartData={this.state.examRankInformation?.chartData} />)
        }
        if (statusPage === 2) {
            return (<ExamRankInformation examInformation={this.state.examInformation} examRankInformation={this.state.examRankInformation} examRank={this.state.examInformation?.studentExamRank} />)
        }
    }
}